import { BaseModel, type RelationConfig } from './base';

import { Customer } from './customer';
import { Order } from './order';

// Enums

export enum TransactionType {
  sale = 0,
  refund = 1,
  addStock = 2,
  returnStock = 3,
  adjustment = 4,
  writeoff = 5,
  damaged = 6,
  outOfDate = 7,
  other = 8,
  internal = 9,
  undefined = 10,
}

export const TransactionTypeLabels: Record<TransactionType, string> = {
  [TransactionType.sale]: 'general.sale',
  [TransactionType.refund]: 'general.refund',
  [TransactionType.addStock]: 'product.addStock',
  [TransactionType.returnStock]: 'product.returnStock',
  [TransactionType.adjustment]: 'product.adjustment',
  [TransactionType.writeoff]: 'product.writtenOff',
  [TransactionType.damaged]: 'product.damaged',
  [TransactionType.outOfDate]: 'product.outOfDate',
  [TransactionType.other]: 'general.other',
  [TransactionType.internal]: 'product.internalUse',
  [TransactionType.undefined]: 'product.undefined',
};

export enum TransactionAction {
  add = 0,
  remove = 1,
}

export const TransactionActionLabels: Record<TransactionAction, string> = {
  [TransactionAction.add]: 'general.add',
  [TransactionAction.remove]: 'general.remove',
};

// Main Model

export class ProductInventoryTransaction extends BaseModel {
  customer!: Customer | null;
  order!: Order | null;
  type!: TransactionType;

  static override relations(): RelationConfig {
    return {
      customer: { type: Customer },
      order: { type: Order },
    };
  }

  static addTypes(): TransactionType[] {
    return [
      TransactionType.refund,
      TransactionType.addStock,
      TransactionType.adjustment,
      TransactionType.other,
    ];
  }

  static removeTypes(): TransactionType[] {
    return [
      TransactionType.sale,
      TransactionType.returnStock,
      TransactionType.adjustment,
      TransactionType.writeoff,
      TransactionType.damaged,
      TransactionType.outOfDate,
      TransactionType.internal,
      TransactionType.other,
    ];
  }
}
